import { useCloseConfirm } from '../../../../Form'
import { FormikForm } from '../../../../Formik'
import { WidgetFormContainer } from '../../../../Widget'
import { getViewingApplicantsPayload } from '../RentalPortalViewingProfileWidgetApplicants.utils'

import { ViewingApplicantsFormFields } from './ViewingApplicantsFormFields'

function ViewingApplicantsForm({
  initialValues,
  listingId,
  primaryApplicantId,
  onClose,
  onSubmit,
  onSuccess,
}) {
  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  function handleSubmit(values, formikHelpers) {
    return onSubmit(getViewingApplicantsPayload(values))
      .then(() => {
        onSuccess()
      })
      .finally(() => {
        formikHelpers.setSubmitting(false)
      })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{ isCloseConfirm, setCloseConfirm, onClose }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={handleSubmit}
    >
      <ViewingApplicantsFormFields
        listingId={listingId}
        primaryApplicantId={primaryApplicantId}
        onCancel={handleClose}
      />
    </FormikForm>
  )
}

export default ViewingApplicantsForm
